import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/global.css'
import { initPush } from './services/push.js'
import { initBackButton } from './services/backButton.js'
import { seedDeepLinks } from './services/viewHistory.js'

seedDeepLinks()
initPush()
initBackButton()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
